<div class="upload-box">
   <i class="fa fa-cloud-upload"></i>
   <br />
   <div class="dragText">Browse for your CSV</div>

   <p-fileupload
      #fileUpload
      (onSelect)="onFileSelect($event)"
      (onRemove)="onFileRemove($event)"
      [multiple]="multiple"
      [accept]="accept"
      [customUpload]="true">
      <ng-template #header>
         <div
            class="p-d-flex p-ai-center p-jc-start"
            style="gap: 0.5rem; display: flex">
            @if (uploadedFiles.value.length > 0 && !(disableUploadButton())) {
            <!-- Choose Button -->
            <button
               type="button"
               pButton
               icon="pi pi-plus"
               label="Choose"
               (click)="fileUpload.choose()"
               [disabled]="disableChooseButton()"
               severity="secondary"></button>

            <!-- Upload Button -->
            <button
               type="button"
               pButton
               icon="pi pi-upload"
               label="Upload"
               (click)="upload()"
               [disabled]="disableUploadButton()"
               severity="primary"></button>
            } @else {
            <!-- Choose Button -->
            <button
               type="button"
               pButton
               icon="pi pi-plus"
               label="Choose"
               (click)="fileUpload.choose()"
               [disabled]="disableChooseButton()"
               severity="primary"></button>

            <!-- Upload Button -->
            <button
               type="button"
               pButton
               icon="pi pi-upload"
               label="Upload"
               (click)="upload()"
               [disabled]="disableUploadButton()"
               severity="secondary"></button>
            }

            <!-- Cancel Button -->
            <button
               type="button"
               pButton
               icon="pi pi-times"
               label="Cancel"
               (click)="onCancelAction()"
               severity="secondary"></button>
         </div>
      </ng-template>
      <ng-template #content>
         <div
            *ngIf="isValidating.value"
            class="validating-message">
            CSV Validating. Please Wait...
         </div>
         <div
            *ngIf="isValidating.value"
            class="spinner-container">
            <p-progressSpinner></p-progressSpinner>
         </div>

         <div
            *ngIf="uploadedFiles.value.length > 0 && !disableUploadButton()"
            class="upload-message">
            Click Above To Upload the File
         </div>

         <div class="my-file-list">
            <div
               *ngFor="let file of uploadedFiles.value; let i = index"
               class="p-d-flex p-ai-center p-jc-between uploaded-file-item"
               [ngClass]="{
                  'uploaded-file-item-validating': isValidating.value,
                  'uploaded-file-item-error': !isValidating.value && hasError(file),
                  'uploaded-file-item-success': !isValidating.value && !hasError(file)
               }">
               <div class="p-fileupload-file">
                  <div class="p-fileupload-file-info">
                     <div class="p-fileupload-file-name">{{ file.name }}</div>
                     <span class="p-fileupload-file-size">{{ file.size.toFixed(3) }} B</span>
                  </div>
                  <div class="p-fileupload-file-actions">
                     <p-button
                        text=""
                        rounded=""
                        severity="danger"
                        icon="pi pi-times"
                        [disabled]="disableChooseButton()"
                        (click)="fileUpload.remove($event, i)" />
                  </div>
               </div>
            </div>
         </div>

         <div *ngFor="let message of errorMessages.value">
            <p-message severity="error">{{ message.index }} - {{ message.message }}</p-message>
         </div>
         <div *ngFor="let message of warningMessages.value">
            <p-message severity="warn">{{ message.index }} - {{ message.message }}</p-message>
         </div>
      </ng-template>
   </p-fileupload>
</div>
